import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from './Header';
import HeroSection from './HeroSection';
import BenchmarkFamilies from './BenchmarkFamilies';
import TaskProposalSection from './TaskProposalSection';
import MethodologySection from './MethodologySection';
import LeaderboardPreview from './LeaderboardPreview';
import PrivateEvalSection from './PrivateEvalSection';
import CTASection from './CTASection';
import Footer from './Footer';

const LandingContainer = styled.div`
  min-height: 100vh;
  background: #ffffff;
`;

const LandingPage = () => {
  useEffect(() => {
    // Handle #docs hash navigation by redirecting to API docs
    if (window.location.hash === '#docs') {
      window.location.href = 'https://api.agent.market/redoc';
    }
  }, []);

  return (
    <LandingContainer>
      <Header />
      <HeroSection />
      <BenchmarkFamilies />
      <TaskProposalSection />
      <MethodologySection />
      <LeaderboardPreview />
      <PrivateEvalSection />
      <CTASection />
      <Footer />
    </LandingContainer>
  );
};

export default LandingPage;
